import '.be{flex-shrink:0;}.ssr-plugin'
import '.bg{padding:1rem;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.bc{height:100%;}.ssr-plugin'
import '.c0{border:none;}.ssr-plugin'
import '.fb{background-color:transparent;}.ssr-plugin'
import '.fc{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.e3{position:sticky;}.ssr-plugin'
import '.fd{top:4rem;}.ssr-plugin'
import '.fe{z-index:7;}.ssr-plugin'
import '.ah{background-color:var(--palette-white);}.ssr-plugin'
import '.ff{padding-bottom:1rem;}.ssr-plugin'
import '.o{margin-bottom:1rem;}.ssr-plugin'
import '.fg{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.s{position:fixed;}.ssr-plugin'
import '.e0{top:0px;}.ssr-plugin'
import '.ba{left:0px;}.ssr-plugin'
import '.bb{right:0px;}.ssr-plugin'
import '.fh{bottom:0px;}.ssr-plugin'
import '.fi{z-index:9999;}.ssr-plugin'
import '.fj{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cs{justify-content:flex-end;}.ssr-plugin'
import '.bl{flex:1;}.ssr-plugin'
import '.ay{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="be bg a1 bc c0 fb fc"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e ae"
    >
      <div className="e3 fd fe ah ff o fg a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="s e0 ba bb fh fi ah fj a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bg a cs fg"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bl ay">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
